<template>
  <b-button
    type="none"
    class="download-button bg-transparent p-0 border-0 position-relative"
    @mouseover="showTooltip = 'download'"
    @mouseleave="showTooltip = null"
    @click="$emit('click')"
  >
    <img
      src="@/core/assets/images/components/download.svg"
      alt="Descargar"
    />

    <custom-tooltip :text="text" v-show="showTooltip" />
  </b-button>
</template>

<script>
import {CustomTooltip} from "@/core/components";

export default {
  name: "DownloadTableData",
  data() {
    return {
      showTooltip: false
    }
  },
  props: {
    text: String
  },
  components: {
    CustomTooltip
  }
};
</script>

<style>
</style>
